var _defs, _tspan, _tspan2, _tspan3, _tspan4, _tspan5, _tspan6, _tspan7, _tspan8, _tspan9, _tspan10, _tspan11, _tspan12, _tspan13, _tspan14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSteps(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "694.67 2000.938 1398.109 411.589",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Urban_Renewal_Tool_-_Homepage_1366px_"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 4535
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Urban_Renewal_Tool_-_Homepage_1366px_",
    "data-name": "Urban Renewal Tool - Homepage 1366px ",
    className: "cls-3",
    style: {
      clipPath: "url(#clip-Urban_Renewal_Tool_-_Homepage_1366px_)"
    },
    transform: "matrix(1, 0, 0, 1, 576.697754, -266.537781)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "process-info",
    transform: "matrix(1, 0, 0, 1, 130.573593, 2278.537598)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2035",
    "data-name": "Group 2035",
    transform: "translate(458.849 40.274)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2924",
    "data-name": "Path 2924",
    className: "cls-1022",
    d: "M464.034,455.093l-16.36-13.386V400.559h16.36Z",
    transform: "translate(-436.492 -384.694)",
    style: {
      fill: "rgb(215, 220, 228)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_784",
    "data-name": "Rectangle 784",
    className: "cls-1022",
    width: 12.243,
    height: 66.433,
    transform: "translate(32.5)",
    style: {
      fill: "rgb(215, 220, 228)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2925",
    "data-name": "Path 2925",
    className: "cls-1022",
    d: "M502.209,448.5,491.3,452.428V420.737h10.914Z",
    transform: "translate(-440.459 -386.529)",
    style: {
      fill: "rgb(215, 220, 228)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2034",
    "data-name": "Group 2034",
    transform: "translate(0 7.883)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2926",
    "data-name": "Path 2926",
    className: "cls-1023",
    d: "M505.006,485.392c-.919-.919-1.863-2.4-4.8-2.4H466.588c-2.669,0-17.343-14.716-19.209-16.808-1.794-2.011-9.789-14.024-12.006-19.209,1.393-1.874,5.157-3.433,9.605-2.4,4.245.986,6.742,4.034,9.6,9.605l9.741,5.113",
    transform: "translate(-435.373 -396.55)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.291px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2927",
    "data-name": "Path 2927",
    className: "cls-1023",
    d: "M493.483,469.338H474.273c-9.6,0-9.6-12.006,0-12.006H486.96c2,0,5.752-4.8,8.923-4.8h12.006c3.245,0,7.275,2.633,9.605,4.8l9.6,9.6",
    transform: "translate(-438.256 -397.304)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.291px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_785",
    "data-name": "Rectangle 785",
    className: "cls-1023",
    width: 40.749,
    height: 16.979,
    transform: "translate(64.831 93.645) rotate(-45)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.291px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_441",
    "data-name": "Line 441",
    className: "cls-1023",
    x1: 4.802,
    y2: 4.802,
    transform: "translate(88.843 76.837)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.291px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2928",
    "data-name": "Path 2928",
    className: "cls-1023",
    d: "M453.863,446.253V410.268h16.808v43.221",
    transform: "translate(-437.055 -393.46)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.291px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2929",
    "data-name": "Path 2929",
    className: "cls-1023",
    d: "M489.161,450.706V391.779H472.353v16.808",
    transform: "translate(-438.736 -391.779)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.291px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2930",
    "data-name": "Path 2930",
    className: "cls-1023",
    d: "M490.842,428.758H507.65v21.61",
    transform: "translate(-440.418 -395.142)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.291px"
    }
  }))), /*#__PURE__*/React.createElement("text", {
    id: "\\u05D4\\u05DE\\u05E9\\u05E7\\u05D9\\u05E2_\\u05DE\\u05E2\\u05D1\\u05D9\\u05E8_\\u05D0\\u05EA_\\u05D4\\u05E9\\u05D0\\u05DC\\u05D5\\u05DF_\\u05DC\\u05D9\\u05D6\\u05DD_-_\\u05D0\\u05D5_-_\\u05D4\\u05D9\\u05D6\\u05DD_\\u05D1\\u05D5\\u05D7\\u05E8_\\u05DC\\u05DE\\u05DC\\u05D0_\\u05E9\\u05D0\\u05DC\\u05D5\\u05DF_",
    "data-name": "\\u05D4\\u05DE\\u05E9\\u05E7\\u05D9\\u05E2 \\u05DE\\u05E2\\u05D1\\u05D9\\u05E8\n\\u05D0\\u05EA \\u05D4\\u05E9\\u05D0\\u05DC\\u05D5\\u05DF \\u05DC\\u05D9\\u05D6\\u05DD\n- \\u05D0\\u05D5 - \n\\u05D4\\u05D9\\u05D6\\u05DD \\u05D1\\u05D5\\u05D7\\u05E8 \\u05DC\\u05DE\\u05DC\\u05D0 \\u05E9\\u05D0\\u05DC\\u05D5\\u05DF\n",
    className: "cls-1021",
    style: {
      fill: "rgb(53, 82, 121)",
      fontFamily: "Assistant-Regular, Assistant",
      fontSize: 26,
      textAnchor: "middle",
      whiteSpace: "pre"
    },
    transform: "matrix(1.141635, 0, 0, 1, -322.682068, 401.439758)"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 1342.84,
    y: -132.636
  }, "\u05D4\u05DE\u05E9\u05E7\u05D9\u05E2 \u05DE\u05E2\u05D1\u05D9\u05E8")), _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 1342.84,
    dy: "1em"
  }, "\u200B")), _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", null, "\u05D0\u05EA \u05D4\u05E9\u05D0\u05DC\u05D5\u05DF \u05DC\u05D9\u05D6\u05DD")), _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: 1342.84,
    dy: "1em"
  }, "\u200B")), /*#__PURE__*/React.createElement("tspan", {
    style: {
      fontWeight: 700
    }
  }, "-\u05D0\u05D5-"), _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    x: 1342.84,
    dy: "1em"
  }, "\u200B")), _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", null, "\u05D4\u05D9\u05D6\u05DD \u05D1\u05D5\u05D7\u05E8 \u05DC\u05DE\u05DC\u05D0 \u05E9\u05D0\u05DC\u05D5\u05DF"))), /*#__PURE__*/React.createElement("line", {
    id: "Line_442",
    "data-name": "Line 442",
    className: "cls-1026",
    x2: 159.45,
    transform: "translate(1133.309 190.171)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.46px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    id: "\\u05D4\\u05D3\\u05D5_\\u05D7_\\u05DE\\u05E9\\u05DE\\u05E9_\\u05D0\\u05EA_\\u05D4\\u05DE\\u05E9\\u05E7\\u05D9\\u05E2_\\u05DB\\u05D1\\u05E1\\u05D9\\u05E1_\\u05DC\\u05D1\\u05D3\\u05D9\\u05E7\\u05EA_\\u05D0\\u05D9\\u05DE\\u05E4\\u05E7\\u05D8_\\u05DB\\u05D7\\u05DC\\u05E7_\\u05DE\\u05D4\\u05E2\\u05E8\\u05DB\\u05EA_\\u05D4\\u05D4\\u05E9\\u05E7\\u05E2\\u05D4_\\u05D5\\u05EA\\u05D4\\u05DC\\u05D9\\u05DA_\\u05E7\\u05D1\\u05DC\\u05EA_\\u05D4\\u05D4\\u05D7\\u05DC\\u05D8\\u05D5\\u05EA_",
    "data-name": "\\u05D4\\u05D3\\u05D5\\u05F4\\u05D7 \\u05DE\\u05E9\\u05DE\\u05E9 \\u05D0\\u05EA \\u05D4\\u05DE\\u05E9\\u05E7\\u05D9\\u05E2 \\u05DB\\u05D1\\u05E1\\u05D9\\u05E1 \\u05DC\\u05D1\\u05D3\\u05D9\\u05E7\\u05EA \\u05D0\\u05D9\\u05DE\\u05E4\\u05E7\\u05D8 \\u05DB\\u05D7\\u05DC\\u05E7 \\u05DE\\u05D4\\u05E2\\u05E8\\u05DB\\u05EA \\u05D4\\u05D4\\u05E9\\u05E7\\u05E2\\u05D4 \\u05D5\\u05EA\\u05D4\\u05DC\\u05D9\\u05DA \\u05E7\\u05D1\\u05DC\\u05EA \\u05D4\\u05D4\\u05D7\\u05DC\\u05D8\\u05D5\\u05EA \n",
    className: "cls-1021",
    style: {
      whiteSpace: "pre",
      fill: "rgb(53, 82, 121)",
      fontFamily: "Assistant-Regular, Assistant",
      fontSize: 26,
      lineHeight: "41.6px",
      perspectiveOrigin: "119.062px 64.5px",
      textAnchor: "middle"
    },
    x: 154.4029998779297,
    y: 505.6650085449219,
    transform: "matrix(1, 0, 0, 1, 0, -243.984589)"
  }, "\u05D4\u05D3\u05D5\"\u05D7 \u05DE\u05E9\u05DE\u05E9 \u05D0\u05EA \u05D4\u05DE\u05E9\u05E7\u05D9\u05E2", _tspan7 || (_tspan7 = /*#__PURE__*/React.createElement("tspan", {
    x: 154.4029998779297,
    dy: "1em"
  }, "\u200B")), "\u05DB\u05D1\u05E1\u05D9\u05E1 \u05DC\u05D1\u05D3\u05D9\u05E7\u05EA \u05D0\u05D9\u05DE\u05E4\u05E7\u05D8", _tspan8 || (_tspan8 = /*#__PURE__*/React.createElement("tspan", {
    x: 154.4029998779297,
    dy: "1em"
  }, "\u200B")), "\u05DB\u05D7\u05DC\u05E7 \u05DE\u05D4\u05E2\u05E8\u05DB\u05EA \u05D4\u05D4\u05E9\u05E7\u05E2\u05D4", _tspan9 || (_tspan9 = /*#__PURE__*/React.createElement("tspan", {
    x: 154.4029998779297,
    dy: "1em"
  }, "\u200B")), "\u05D5\u05EA\u05D4\u05DC\u05D9\u05DA \u05E7\u05D1\u05DC\u05EA \u05D4\u05D4\u05D7\u05DC\u05D8\u05D5\u05EA", /*#__PURE__*/React.createElement("tspan", {
    x: 281.504,
    y: 633.665,
    style: {
      fontSize: 26,
      wordSpacing: 0
    }
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_443",
    "data-name": "Line 443",
    className: "cls-1026",
    x2: 159.45,
    transform: "translate(75.531 190.171)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.46px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    id: "\\u05D4\\u05D9\\u05D6\\u05DD_\\u05DE\\u05DE\\u05DC\\u05D0_\\u05D0\\u05EA_\\u05D4\\u05E9\\u05D0\\u05DC\\u05D5\\u05DF_\\u05D5\\u05DE\\u05E7\\u05D1\\u05DC_\\u05D3\\u05D5_\\u05D7_\\u05D4\\u05DB\\u05D5\\u05DC\\u05DC_\\u05E0\\u05D9\\u05E7\\u05D5\\u05D3_\\u05DC\\u05E4\\u05E8\\u05D5\\u05D9\\u05E7\\u05D8_",
    "data-name": "\\u05D4\\u05D9\\u05D6\\u05DD \\u05DE\\u05DE\\u05DC\\u05D0 \\u05D0\\u05EA \\u05D4\\u05E9\\u05D0\\u05DC\\u05D5\\u05DF \\u05D5\\u05DE\\u05E7\\u05D1\\u05DC \\u05D3\\u05D5\\u05F4\\u05D7 \\u05D4\\u05DB\\u05D5\\u05DC\\u05DC \\u05E0\\u05D9\\u05E7\\u05D5\\u05D3 \\u05DC\\u05E4\\u05E8\\u05D5\\u05D9\\u05E7\\u05D8\n",
    className: "cls-1021",
    style: {
      whiteSpace: "pre",
      fill: "rgb(53, 82, 121)",
      fontFamily: "Assistant-Regular, Assistant",
      fontSize: 26,
      lineHeight: "41.6px",
      perspectiveOrigin: "189.141px 48.5px",
      textAnchor: "middle"
    },
    y: 538.718994140625,
    x: 721.7340087890625,
    transform: "matrix(1, 0, 0, 1, 140.376266, -254.02771)"
  }, "\u05D4\u05D9\u05D6\u05DD \u05DE\u05DE\u05DC\u05D0 \u05D0\u05EA", _tspan10 || (_tspan10 = /*#__PURE__*/React.createElement("tspan", {
    x: 721.7340087890625,
    dy: "1em"
  }, "\u200B")), "\u05D4\u05E9\u05D0\u05DC\u05D5\u05DF \u05D5\u05DE\u05E7\u05D1\u05DC \u05D3\u05D5\"\u05D7", _tspan11 || (_tspan11 = /*#__PURE__*/React.createElement("tspan", {
    x: 721.7340087890625,
    dy: "1em"
  }, "\u200B")), "\u05D4\u05DB\u05D5\u05DC\u05DC \u05E0\u05D9\u05E7\u05D5\u05D3 \u05DC\u05E4\u05E8\u05D5\u05D9\u05D9\u05E7\u05D8"), /*#__PURE__*/React.createElement("line", {
    id: "Line_444",
    "data-name": "Line 444",
    className: "cls-1026",
    x2: 159.45,
    transform: "translate(780.523 190.171)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.46px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    id: "\\u05D4\\u05D9\\u05D6\\u05DD_\\u05DE\\u05D2\\u05D9\\u05E9_\\u05D0\\u05EA_\\u05D4\\u05D3\\u05D5_\\u05D7_\\u05DC\\u05DE\\u05E9\\u05E7\\u05D9\\u05E2_",
    "data-name": "\\u05D4\\u05D9\\u05D6\\u05DD \\u05DE\\u05D2\\u05D9\\u05E9 \\u05D0\\u05EA \\u05D4\\u05D3\\u05D5\\u201D\\u05D7 \\u05DC\\u05DE\\u05E9\\u05E7\\u05D9\\u05E2\n",
    className: "cls-1021",
    style: {
      fill: "rgb(53, 82, 121)",
      fontFamily: "Assistant-Regular, Assistant",
      fontSize: "21.6728px",
      whiteSpace: "pre",
      textAnchor: "middle"
    },
    transform: "matrix(1.135468, 0, 0, 1.199659, -1179.895142, -105.518616)"
  }, _tspan12 || (_tspan12 = /*#__PURE__*/React.createElement("tspan", {
    x: 1485.47,
    y: 331.047
  }, "\u05D4\u05D9\u05D6\u05DD \u05DE\u05D2\u05D9\u05E9 \u05D0\u05EA")), _tspan13 || (_tspan13 = /*#__PURE__*/React.createElement("tspan", {
    x: 1485.47,
    dy: "1em"
  }, "\u200B")), _tspan14 || (_tspan14 = /*#__PURE__*/React.createElement("tspan", null, "\u05D4\u05D3\u05D5\"\u05D7 \u05DC\u05DE\u05E9\u05E7\u05D9\u05E2"))), /*#__PURE__*/React.createElement("line", {
    id: "Line_445",
    "data-name": "Line 445",
    className: "cls-1026",
    x2: 159.45,
    transform: "translate(428.027 190.171)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.46px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2036",
    "data-name": "Group 2036",
    transform: "translate(1162.94 43.426)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2931",
    "data-name": "Path 2931",
    className: "cls-1027",
    d: "M1150.692,422.779v-17.4h43.964v89.151",
    transform: "translate(-1094.466 -384.15)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.344px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_446",
    "data-name": "Line 446",
    className: "cls-1028",
    x2: 22.875,
    transform: "translate(66.77 33.863)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeDasharray: "0.922px, 10.758px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.344px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_447",
    "data-name": "Line 447",
    className: "cls-1028",
    x2: 22.875,
    transform: "translate(66.77 43.087)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeDasharray: "0.922px, 10.758px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.344px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_448",
    "data-name": "Line 448",
    className: "cls-1028",
    x2: 22.875,
    transform: "translate(66.77 52.311)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeDasharray: "0.922px, 10.758px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.344px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_449",
    "data-name": "Line 449",
    className: "cls-1028",
    x2: 22.875,
    transform: "translate(66.77 61.535)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeDasharray: "0.922px, 10.758px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.344px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_450",
    "data-name": "Line 450",
    className: "cls-1028",
    x2: 22.875,
    transform: "translate(66.77 70.76)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeDasharray: "0.922px, 10.758px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.344px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_451",
    "data-name": "Line 451",
    className: "cls-1028",
    x2: 22.875,
    transform: "translate(66.77 79.984)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeDasharray: "0.922px, 10.758px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.344px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2932",
    "data-name": "Path 2932",
    className: "cls-1027",
    d: "M1178.984,497.812v-19.1H1167.9v19.1",
    transform: "translate(-1095.236 -387.432)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.344px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2933",
    "data-name": "Path 2933",
    className: "cls-1027",
    d: "M1160.865,404.98v-8.547h24.528v8.547",
    transform: "translate(-1094.922 -383.75)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.344px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_452",
    "data-name": "Line 452",
    className: "cls-1027",
    y1: 12.683,
    transform: "translate(78.207)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.344px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_786",
    "data-name": "Rectangle 786",
    className: "cls-1029",
    width: 27.614,
    height: 21.074,
    transform: "translate(0 82.77)",
    style: {
      fill: "rgb(215, 220, 228)",
      stroke: "rgb(215, 220, 228)",
      strokeMiterlimit: 10,
      strokeWidth: "1.115px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2934",
    "data-name": "Path 2934",
    className: "cls-1027",
    d: "M1131.551,425.348c-11.2,0-20.167,6.043-20.167,13.445v24.648",
    transform: "translate(-1092.707 -385.044)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.344px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2935",
    "data-name": "Path 2935",
    className: "cls-1027",
    d: "M1132.076,417.261a8.591,8.591,0,0,0,8.963-8.963v-4.482a8.963,8.963,0,1,0-17.926,0V408.3A8.591,8.591,0,0,0,1132.076,417.261Z",
    transform: "translate(-1093.232 -383.679)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.344px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_453",
    "data-name": "Line 453",
    className: "cls-1027",
    y2: 22.408,
    transform: "translate(27.64 55.99)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.344px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2936",
    "data-name": "Path 2936",
    className: "cls-1027",
    d: "M1132.5,425.348c11.2,0,20.167,6.043,20.167,13.445V456.72c0,2.241,0,8.964-8.963,8.964",
    transform: "translate(-1093.652 -385.044)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.344px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_454",
    "data-name": "Line 454",
    className: "cls-1027",
    y2: 53.779,
    transform: "translate(50.048 55.99)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.344px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_455",
    "data-name": "Line 455",
    className: "cls-1027",
    y2: 11.204,
    transform: "translate(27.64 98.565)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.344px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_456",
    "data-name": "Line 456",
    className: "cls-1027",
    y2: 31.371,
    transform: "translate(41.085 78.398)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.344px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_787",
    "data-name": "Rectangle 787",
    className: "cls-1027",
    width: 24.649,
    height: 20.167,
    transform: "translate(7.473 78.398)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.344px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2038",
    "data-name": "Group 2038",
    transform: "translate(112.862 43.426)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_117",
    "data-name": "Ellipse 117",
    className: "cls-1022",
    cx: 22.165,
    cy: 22.165,
    r: 22.165,
    transform: "translate(45.573 44.643)",
    style: {
      fill: "rgb(215, 220, 228)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2037",
    "data-name": "Group 2037"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2937",
    "data-name": "Path 2937",
    className: "cls-1030",
    d: "M178.533,397.052h19.819v31.115m0,64.977H117.2V397.052h20.176m12.239-6.033h3.156a5,5,0,0,1,10.01,0h3.157a6.033,6.033,0,0,1,0,12.066H149.614a6.033,6.033,0,0,1,0-12.066Z",
    transform: "translate(-117.199 -386.016)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.219px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2938",
    "data-name": "Path 2938",
    className: "cls-1030",
    d: "M129.746,419.069h32.288m-32.288,14.668h32.288M129.746,448.4h32.288",
    transform: "translate(-117.556 -386.957)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.219px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2939",
    "data-name": "Path 2939",
    className: "cls-1030",
    d: "M170.32,449.027a17.3,17.3,0,1,1,11.126,21.789,17.3,17.3,0,0,1-11.126-21.789Z",
    transform: "translate(-118.687 -387.469)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.219px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2940",
    "data-name": "Path 2940",
    className: "cls-1030",
    d: "M197.591,478.434l7.8-5.3,12.357,18.2a4.716,4.716,0,1,1-7.785,5.323l-12.374-18.221Zm-.328-8.875,4.23,6.227",
    transform: "translate(-119.478 -388.394)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.219px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2941",
    "data-name": "Path 2941",
    className: "cls-1031",
    d: "M1005.755,498.6V362.573a16.676,16.676,0,0,1,16.628-16.628h277.258a16.676,16.676,0,0,1,16.627,16.628V717.829a16.676,16.676,0,0,1-16.627,16.628H1022.383a16.676,16.676,0,0,1-16.628-16.628V551.522a16.676,16.676,0,0,0-16.628-16.627H940.909",
    transform: "translate(51.733 -345.945)",
    style: {
      fill: "none",
      stroke: "rgb(174, 186, 201)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2942",
    "data-name": "Path 2942",
    className: "cls-1031",
    d: "M965.34,497.57l-28.266,26.362,28.266,27.094",
    transform: "translate(51.412 -334.249)",
    style: {
      fill: "none",
      stroke: "rgb(174, 186, 201)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2943",
    "data-name": "Path 2943",
    className: "cls-1031",
    d: "M991.006,563.118v139.1a16.676,16.676,0,0,1-16.627,16.627H697.122a16.676,16.676,0,0,1-16.628-16.627V538.861a16.676,16.676,0,0,0-16.628-16.628H615.648",
    transform: "translate(24.498 -331.184)",
    style: {
      fill: "none",
      stroke: "rgb(174, 186, 201)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2944",
    "data-name": "Path 2944",
    className: "cls-1031",
    d: "M675.484,499.752V362.573a16.676,16.676,0,0,1,16.628-16.628H969.37A16.676,16.676,0,0,1,986,362.573V492.015",
    transform: "translate(29.508 -345.945)",
    style: {
      fill: "none",
      stroke: "rgb(174, 186, 201)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2945",
    "data-name": "Path 2945",
    className: "cls-1031",
    d: "M640.079,497.57l-28.266,26.362,28.266,27.094",
    transform: "translate(24.176 -334.249)",
    style: {
      fill: "none",
      stroke: "rgb(174, 186, 201)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2946",
    "data-name": "Path 2946",
    className: "cls-1031",
    d: "M311.119,497.57l-28.266,26.362,28.266,27.094",
    transform: "translate(-1.368 -334.249)",
    style: {
      fill: "none",
      stroke: "rgb(174, 186, 201)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2947",
    "data-name": "Path 2947",
    className: "cls-1031",
    d: "M665.745,563.118v139.1a16.676,16.676,0,0,1-16.628,16.627H371.861a16.676,16.676,0,0,1-16.628-16.627V538.861a16.676,16.676,0,0,0-16.628-16.628H290.387",
    transform: "translate(-2.737 -331.184)",
    style: {
      fill: "none",
      stroke: "rgb(174, 186, 201)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2948",
    "data-name": "Path 2948",
    className: "cls-1031",
    d: "M350.223,499.752V362.573a16.676,16.676,0,0,1,16.628-16.628H644.107a16.676,16.676,0,0,1,16.628,16.628V492.015",
    transform: "translate(2.273 -345.945)",
    style: {
      fill: "none",
      stroke: "rgb(174, 186, 201)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2949",
    "data-name": "Path 2949",
    className: "cls-1031",
    d: "M335.474,577.519v140.31a16.676,16.676,0,0,1-16.628,16.628H41.59a16.676,16.676,0,0,1-16.628-16.628V362.573A16.676,16.676,0,0,1,41.59,345.945H318.846a16.676,16.676,0,0,1,16.628,16.628V492.015",
    transform: "translate(-24.962 -345.945)",
    style: {
      fill: "none",
      stroke: "rgb(174, 186, 201)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2039",
    "data-name": "Group 2039",
    transform: "translate(814.819 48.971)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2950",
    "data-name": "Path 2950",
    className: "cls-1032",
    d: "M820.416,409.094h38.355l-14.383,26.369H805.64Z",
    transform: "translate(-773.761 -396.002)",
    style: {
      fill: "rgb(215, 220, 228)",
      stroke: "rgb(215, 220, 228)",
      strokeMiterlimit: 10,
      strokeWidth: "1.086px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2951",
    "data-name": "Path 2951",
    className: "cls-1033",
    d: "M799.9,419.728c-5.506,0-9.319-4.47-9.319-9.984v-3.329c0-5.513,3.813-9.983,9.319-9.983s9.318,4.47,9.318,9.983v3.33C809.217,415.258,805.4,419.728,799.9,419.728Z",
    transform: "translate(-774.272 -396.432)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.259px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2952",
    "data-name": "Path 2952",
    className: "cls-1033",
    d: "M821.172,497.944l-13.978-25.627H790.886A9.347,9.347,0,0,1,781.567,463V432.712a7.01,7.01,0,0,1,6.988-6.988h6.99L807.194,439.7h13.978s1.042,9.319-6.988,9.319H800.205l-9.319-11.649",
    transform: "translate(-774.578 -395.437)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.259px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2953",
    "data-name": "Path 2953",
    className: "cls-1033",
    d: "M797.339,446v11.649H807.4c3.73,0,7.342,1.137,8.574,4.659l16.308,34.946",
    transform: "translate(-774.043 -394.749)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.259px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2954",
    "data-name": "Path 2954",
    className: "cls-1033",
    d: "M802.764,478.923H786.457a11.682,11.682,0,0,1-11.649-11.649V436.989",
    transform: "translate(-774.808 -395.055)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.259px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_457",
    "data-name": "Line 457",
    className: "cls-1033",
    y2: 18.638,
    transform: "translate(13.978 83.869)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.259px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2955",
    "data-name": "Path 2955",
    className: "cls-1033",
    d: "M813.112,433.018l9.319-16.308h37.275l-13.978,25.627H827.09",
    transform: "translate(-773.507 -395.743)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.259px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_458",
    "data-name": "Line 458",
    className: "cls-1033",
    x2: 67.561,
    transform: "translate(23.297 53.583)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.259px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_459",
    "data-name": "Line 459",
    className: "cls-1033",
    x2: 23.297,
    transform: "translate(2.329 102.506)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.259px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_460",
    "data-name": "Line 460",
    className: "cls-1033",
    y2: 51.253,
    transform: "translate(79.209 53.583)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.259px"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSteps);
export default __webpack_public_path__ + "static/media/steps.dd2c30a04657c39dbccdd4a3fd0798e0.svg";
export { ForwardRef as ReactComponent };